import { useEffect } from "react";
import "./App.css";
import "./pages/HomePage.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./lib/i18n";
import { trackPageview } from "./utils/analytics";
import AnalyticsInjector from "./components/AnalyticsInjector";
import HomePage from "./pages/HomePage";
import TirzepatidePage from "./pages/TirzepatidePage";
import NADPage from "./pages/NADPage";
import SermorelinPage from "./pages/SermorelinPage";
import ProgramsPage from "./pages/ProgramsPage";
import StaticPage from "./pages/StaticPage";
import IntakeStart from "./pages/IntakeStart";
import IntakeRunner from "./pages/IntakeRunner";
import IntakeFinalize from "./pages/IntakeFinalize";
import IntakeIneligible from "./pages/IntakeIneligible";
import IntakeResults from "./pages/IntakeResults";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderSuccess from "./pages/OrderSuccess";
import LoginPage from "./pages/LoginPage";
import SetupPasswordPage from "./pages/SetupPasswordPage";
import AccountPage from "./pages/AccountPage";
import AppointmentSlugPage from "./pages/AppointmentSlugPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboard from "./pages/AdminDashboard";

function PageviewTracker() {
  const loc = useLocation();
  useEffect(() => { trackPageview(loc.pathname + loc.search); }, [loc.pathname, loc.search]);
  return null;
}

export default function App() {
  useEffect(() => { document.documentElement.style.background = "#1C2B1A"; }, []);
  return (
    <LanguageProvider>
    <BrowserRouter>
      <Toaster position="top-right" theme="dark" />
      <AnalyticsInjector />
      <PageviewTracker />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/tirzepatide" element={<TirzepatidePage />} />
        <Route path="/nad" element={<NADPage />} />
        <Route path="/sermorelin" element={<SermorelinPage />} />
        <Route path="/estore" element={<ProgramsPage />} />
        <Route path="/shop" element={<Navigate to="/estore" replace />} />
        <Route path="/programs" element={<ProgramsPage />} />
        <Route path="/intake/start" element={<IntakeStart />} />
        <Route path="/intake" element={<IntakeRunner />} />
        <Route path="/intake/finalize" element={<IntakeFinalize />} />
        <Route path="/intake/ineligible" element={<IntakeIneligible />} />
        <Route path="/intake/results" element={<IntakeResults />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/order-success" element={<OrderSuccess />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/setup-password" element={<SetupPasswordPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/appointments" element={<Navigate to="/appointments/free-consultation" replace />} />
        <Route path="/appointments/:slug" element={<AppointmentSlugPage />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
      </Routes>
    </BrowserRouter>
    </LanguageProvider>
  );
}
